import $ from 'jquery';
import * as noUiSlider from 'nouislider';
import { reduce, map } from 'lodash';

const BASE_SELECTOR: string = '[data-ram-mod]';

export class RamModUI {
    public constructor(private $base: JQuery) {
        this.$base.find('.modal-close').on('click', (e) => {
            this.hideModal();
        });
    }
    
    public onAddRamClick(callback: () => {}) {
        this.$base.find('.changeQuota').on('click', (e) => {
            e.preventDefault();
            callback();
        });
    }
    
    public getFormData() {
        return this.$base.find('#RamUpdateRamForm').serialize();
    }
    
    public updatePriceInfo(data, units) {
        if (data) {
            let total = data.price;
            this.$base.find('.price').css({color: '#03433B'});
            this.$base.find('.price input').css({color: '#03433B'});
            if (data.afterRefundPriceFormatted != undefined && data.afterRefundPriceFormatted) {
                this.$base.find('#price-brutto').val(data.afterRefundPrice);
                this.$base.find('#full-price').val(data.price);
                this.$base.find('#priceBruttoFormatted').html(data.afterRefundPriceFormatted);
                this.$base.find('#mods-space-summary').html(
                    '<h5>' + units + ' GB [ ' + data.priceFormatted + ' ]</h5>' +
                    '<h5>' + data.refundedText + ' -' + data.refundedPriceFormatted + '</h5>'
                );
                this.$base.find('#mods-space-summary').fadeIn();
            } else {
                this.$base.find('#price-brutto, #full-price').val(total);
                this.$base.find('#priceBruttoFormatted').html(data.priceFormatted);
            }
            this.$base.find('span.price').hide().fadeIn('slow');
        }
    }
    
    public disableButton(buttonClass: string) {
        this.$base.find(buttonClass).addClass('loading').attr('disabled', 'disabled');
    }
    
    public enableButton(buttonClass: string) {
        this.$base.find(buttonClass).removeClass('loading').removeAttr('disabled');
    }
    
    public onGetMoreRamClick(callback: () => {}) {
        this.$base.find('.add-more-ram').on('click', (e) => {
            e.preventDefault();
            callback();
        });
    }
    
    public onDeactivateRamClick(callback: () => {}) {
        this.$base.find('.deactivate-mod').on('click', (e) => {
            e.preventDefault();
            callback();
        });
    }
    
    public showModal() {
        this.$base.find('#ram-mod').addClass('active');
        setTimeout(() => {
            this.$base.find('#ram-mod').addClass('in');
        }, 50);
    }
    
    public hideModal() {
        this.$base.find('#ram-mod')
            .removeClass('active')
            .removeClass('in');
    }
    
    public resetModal() {
        this.$base.find('#mods-space-summary').fadeOut().html('');
        this.$base.find('#price-brutto').val($('#price-brutto').attr('data-default'));
        this.$base.find('#priceBruttoFormatted').html($('#full-price').attr('data-default'));
        this.$base.find('#RamSize').val(window.currentSize).trigger('change');
    }
    
    public setUnits(newSize) {
        this.$base.find('#RamSize').val(newSize)
    }
    
    public render(callback: (slots: number) => {}) {
        const range = document.getElementById('pips-steps');
        const wNumb = require('wnumb');
        this.$base.find('#RamSize').val(window.currentSize);
        const slider = noUiSlider.create(range, {
            start: window.currentSize,
            range: window.sliderRange,
            snap: false,
            connect: true,
            pips: {
                mode: 'values',
                values: window.sliderValues,
                stepped: true,
                density: 100,
                format: wNumb({
                    postfix: ' GB',
                    decimals: 0
                })
            }
        });
        
        slider.on('change', (values) => {
            let slots = values[0];
            let target = Math.round(slots);
            // a try to solve it with es6 instead of lodash
            // let tuples = (window.sliderValues as []).map((value) => [value, Math.abs(value - target)]);
            // let newSize = tuples.reduce((memo, value) => (memo[0] < value[1]) ? memo : value)
           
            let tuples = map(window.sliderValues, function (val) {
                return [val, Math.abs(val - target)];
            });
            
            let newSize = reduce(tuples, function (memo, val) {
                return (memo[1] < val[1]) ? memo : val;
            }, [-1, 999])[0];
            
            slider.set(newSize);
            this.$base.find('#RamSize').val(newSize);
            callback(newSize);
        });
        
        this.$base.find('#RamSize').on('keyup change', () => {
            slider.set(this.$base.find('#RamSize').val());
        });
    }
}

export function createRamModInstances(): RamModUI[] {
    const instances: RamModUI[] = [];
    $(BASE_SELECTOR).each((index, element) => {
        instances.push(new RamModUI($(element)));
    });
    
    return instances;
}
